import { Zone } from "./zone";
import { ResourceModel } from "@app/models/rest/resource";
import { BaseEntity } from "@app/models/rest/base-entity";
import {
  HateoasProjection,
  HateoasResource,
  ProjectionRelType
} from "@lagoshny/ngx-hateoas-client";
import { ResourceFactMappingPattern } from "./resource-fact-mapping-pattern";

@HateoasResource("resourceZones")
export class ResourceZone extends BaseEntity {
  zone: ProjectionRelType<Zone>;
  resource: ProjectionRelType<ResourceModel>;
  startDate: Date;
  endDate: Date;
  mappingPattern: ProjectionRelType<ResourceFactMappingPattern>;
}

/**
 * Detail projection that includes all related entities needed for the resource-zone-mapping component
 */
@HateoasProjection(ResourceZone, "detail")
export class ResourceZoneDetailProjection extends BaseEntity {
  resource: ProjectionRelType<ResourceModel>;
  zone: ProjectionRelType<Zone>;
  startDate: Date;
  endDate: Date;
  mappingPattern: ProjectionRelType<ResourceFactMappingPattern>;
}
